import { useEffect, useRef, useState } from "react";

import { RemoteVideoStream, RemoteAudioStream } from "@skyway-sdk/room";
import { Box, Button } from "@mui/material";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export const RemoteMedia = ({
  stream, pharmacyPaused, setPharmacyPaused
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      stream.attach(ref.current);
    }
  }, [stream]);

  const resume = () => {
    setPharmacyPaused(false)
  }

  useEffect(() => {
    if (ref && ref.current) {
      if (!pharmacyPaused) {
        ref.current.play().catch(error => console.error(error))
      }  
    }
  }, [pharmacyPaused]);


  if (stream.track.kind === "video") {
    return (
      <div style={{height: 245, position: 'relative'}}>
        <video 
          ref={ref} 
          autoPlay 
          playsInline 
          style={{objectFit: 'cover', width: '100%', height: '100%'}} 
          onPause={()=>setPharmacyPaused(true)}
          onPlaying={()=>setPharmacyPaused(false)}
        />
        {pharmacyPaused && (
          <Box sx={{position: 'absolute', top:0, left: 0, width: '100%', height: '100%', display:'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10}}>
              <Button onClick={()=>resume()} variant="outlined" color="success" sx={{backgroundColor: "rgba(255,255,255,0.4)"}}>
                  <PlayArrowIcon sx={{fontSize: 40}}></PlayArrowIcon>
              </Button>
          </Box>
        )}
      </div>
    );
  } else if (stream.track.kind === "audio") {
    return (
      <Box sx={{height: 0, overflow: 'hidden'}}>
        <audio ref={ref} autoPlay controls />
      </Box>
    );
  }

  return null;
};
